import 'fslightbox';
import Cookies from 'js-cookie';

// Cookie notice
( () => {
  const cookie_notice = document.querySelector( '.cookie-notice' );

  if ( !cookie_notice ) {
    return;
  }

  const opt_in_button = cookie_notice.querySelector( '[data-cookies-option="accept"]' );
  const opt_out_button = cookie_notice.querySelector( '[data-cookies-option="deny"]' );

  if ( Cookies.get( 'cookieconsent_status' ) == undefined ) {
    cookie_notice.classList.add( 'cookie-notice--visible' );

    window.addEventListener( 'click', ( e ) => {
      if ( e.target == opt_in_button ) {
        Cookies.set( 'cookieconsent_status', 'allow', { sameSite: 'none', secure: true, expires: 60 } );
        location.reload();
      } else if ( e.target == opt_out_button ) {
        Cookies.set( 'cookieconsent_status', 'disallow', { sameSite: 'none', secure: true, expires: 60 } );
        location.reload();
      }
    } );
  }
} )();

// Cookie controls
( () => {
  const cookie_controls = document.querySelector( '.cookie-controls' );

  if ( !cookie_controls ) {
    return;
  }

  const opt_in_button = cookie_controls.querySelector( '[data-cookies-option="in"]' );
  const opt_out_button = cookie_controls.querySelector( '[data-cookies-option="out"]' );

  if ( opt_in_button && opt_out_button ) {
    window.addEventListener( 'click', ( e ) => {
      if ( e.target == opt_in_button ) {
        Cookies.set( 'cookieconsent_status', 'allow', { sameSite: 'none', secure: true, expires: 60 } );
        location.reload();
      } else if ( e.target == opt_out_button ) {
        Cookies.set( 'cookieconsent_status', 'disallow', { sameSite: 'none', secure: true, expires: 60 } );
        Cookies.remove( '_ga', { path: '/', domain: '.thebailliegiffordprize.co.uk' } );
        Cookies.remove( '_ga_J01RN6DY2G', { path: '/', domain: '.thebailliegiffordprize.co.uk' } );
        location.reload();
      }
    } );
  }
} )();

// Swappers
( () => {
	function doSwap( swapper ) {
		const swap_target = document.querySelectorAll( swapper.getAttribute( 'data-swap-target' ) );
		for ( let i = 0; i < swap_target.length; i += 1 ) {
			swap_target[i].classList.toggle( 'swapped', !swap_target[i].classList.contains( 'swapped' ) );
		}
		swapper.classList.toggle( 'swapper--swapped', !swapper.classList.contains( 'swapper--swapped' ) );
	}

	window.addEventListener( 'click', ( event ) => {
		if ( !event.target.classList.contains( 'swapper' ) ) {
			return;
		}
		doSwap( event.target );
	} );
} )();

// Header controls
( () => {
  const list = document.querySelector( '.header__list' );
  const nav = document.querySelector( '.header__nav' );
  const toggle = document.querySelector( '.header__nav-toggle' );

  const observer = new MutationObserver( mutations =>
    mutations.forEach( mutationRecord => onLineWrapDoSomething() )
  );
  observer.observe( nav, {
    attributes: true,
    attributeFilter: ['style']
  } );

  window.addEventListener( 'resize', onLineWrapDoSomething );
  window.addEventListener( 'DOMContentLoaded', onLineWrapDoSomething );

  function onLineWrapDoSomething() {
    const { lineHeight } = getComputedStyle( list );
    const lineHeightParsed = parseInt(lineHeight.split('px')[0]);
    const amountOfLinesTilAdjust = 2;

    if ( list.offsetHeight >= ( lineHeightParsed * amountOfLinesTilAdjust ) ) {
      toggle.classList.remove( 'hidden' );
    } else {
      toggle.classList.add( 'hidden' );
    }
  }
} )();

// Filter lists
( () => {
  const filter_toggles = document.querySelectorAll( '.filter__group' );
  const filter_lists = document.querySelectorAll( '.filter__list' );

  if ( !filter_toggles || !filter_lists ) {
    return;
  }

  function closeOpenItems( e ) {
    if ( !e.target.closest( '.filter__list' ) ) {
      filter_lists.forEach( function( list ) {
        list.classList.remove( 'filter__list--open' );
      } );
      filter_toggles.forEach( function( toggle ) {
        toggle.classList.remove( 'filter__group--open' );
      } );
    }
  }

  filter_toggles.forEach( function( toggle ) {
    toggle.addEventListener( 'click', function( e ) {
      var toggle_list = toggle.querySelector( '.filter__list' );
      var should_open = !toggle_list.classList.contains( 'filter__list--open' );

      closeOpenItems( e );

      if ( should_open ) {
        toggle.classList.add( 'filter__group--open' );
        toggle_list.classList.add( 'filter__list--open' );
      }
      e.stopPropagation();
    } );
  } );

  // Close lists when clicking outside of them
  window.addEventListener( 'click', function( e ) {
    if ( e.target != filter_toggles ) {
      closeOpenItems( e );
    }
  } );
} )();
